import { store } from "../store/store";
import axios from "axios";
import { types } from '../types/types'

//Método para set los servicios en el estado
export const setServices = (services) => ({
    type: types.loadServices,
    payload: services
});

//Método para set los estados civiles en el estado
export const setCivilStates = (states) => ({
    type: types.loadCivilStates,
    payload: states
});

//Método para set los planes médicos en el estado
export const setMedicalPlanes = (planes) => ({
    type: types.loadMedicalPlanes,
    payload: planes
});

//Método para set los niveles de educacion en el estado
export const setEducationLevels = (education) => ({
    type: types.loadEducationLevels,
    payload: education
});

//Método para set los generos en el estado
export const setGenders = (genders) => ({
    type: types.loadGenders,
    payload: genders
});

//Método para set los chats en el estado
export const setChatsProfessional = (chats) => ({
    type: types.loadChatProfessional,
    payload: chats
});

//Método para set los chats en el estado
export const setChatsCustomer = (chats) => ({
    type: types.loadChatCustomer,
    payload: chats
});

//Método para set los usuarios mobile en el estado
export const setUsersMobile = (users) => ({
    type: types.loadUsersMobile,
    payload: users
});

export const loadCompanyPermissions = () => {
    const reduxState = store.getState().company;
    const urlServer = reduxState.companyInstance.urlServer;

    return async (dispatch) => {
        axios.get(`${urlServer}/getPermissionsFromDB`).then((response) => {
            const { data } = response;
            const list = [];
            data.forEach((perm) => {
                list.push(perm);
            });
            dispatch(setCompanyPermissions(list));
        });
    }
}

//Método para set los usuarios mobile en el estado
export const setCompanyPermissions = (users) => ({
    type: types.loadCompanyPermissions,
    payload: users
});

//Método para set los permisos de las rutas provenientes del server para marca blanca
export const setCompanyPermissionsRoutes = (permissions) => ({
    type: types.loadCompanyPermissionsRoutes,
    payload: permissions
});

//Método para set los permisos de las integraciones para marca blanca
export const setCompanyPermissionsIntegrations = (permissions) => ({
    type: types.loadCompanyPermissionsIntegrations,
    payload: permissions
});

//Método para set los tags manager para marca blanca
export const setCompanyTagsManager = (permissions) => ({
    type: types.loadCompanyTagsManager,
    payload: permissions
});

//Método para set los recursos para marca blanca
export const setCompanyResources = (resources) => ({
    type: types.loadCompanyResources,
    payload: resources
});

//Método para set los permisos de las rutas provenientes del server para marca blanca
export const setCompanyLoadedToRedux = (company) => ({
    type: types.loadedCompany,
    payload: company
});

//Método para set el footer de los documentos para marca blanca
export const setFooterLoadedToRedux = (company) => ({
    type: types.loadCompanyDocumentFooter,
    payload: company
});

//Método para set los permisos de las rutas provenientes del server para marca blanca
export const setCompanyInstanceToRedux = (instance) => ({
    type: types.companyInstance,
    payload: instance
});

//Método para set los usuarios mobile en el estado
export const setProfessionalMobile = (users) => ({
    type: types.loadProfessionalMobile,
    payload: users
});

export const clearPermissions = () => ({
    type: types.clearCompanyPermissions
});

export const clearPermissionsUser = () => ({
    type: types.clearPermissionsUser
});